import React, { useEffect, useState } from "react";
import airplaneImage from "../../src/assets/img/airplane.png"; // Update with your ac
const ScrollAirplaneAnimation = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;

      // Trigger animation when scrolled past 20% of the page
      if (scrollPosition > windowHeight * 0.2) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="airplane-animation-container">
      <img
        src={airplaneImage}
        alt="Flying Airplane"
        className={`airplane-image ${isVisible ? "fly-up" : ""}`}
      />
    </div>
  );
};

export default ScrollAirplaneAnimation;
